export default __webpack_public_path__ + "static/media/building-icon-selected-light.652fb4dd.svg";